<template>
  <div class="cpr00100-reissue">
    <PageHeaderBanner>
      <template #title>パスワード再発行依頼</template>
    </PageHeaderBanner>
    <MessageChip :display="isMessageChip" level="E" :message="errMessage" />
    <q-form autofocus greedy novalidate @submit="resetPassword" @validation-error="resetError">
      <div class="cpr00100-reissue-form">
        <q-card bordered flat class="bg-grey-2 cpr00100-form-card" style="padding: 50px 10%">
          <q-card-section>
            <label>会員ID（メールアドレス）</label>
            <q-input
              id="mail_address"
              v-model="mailAddress"
              outlined
              name="mail_address"
              dense
              :rules="[
                (val) => isEmpty(val) || $t('validation.required'),
                (val) => isValidateEmail(val) || $t('validation.email'),
              ]"
              lazy-rules
              maxlength="254"
              type="email"
              bg-color="white"
              class="input-area left-input"
              :error="isMessageChip"
              @keydown.enter.prevent
            />
          </q-card-section>
          <q-card-actions align="center">
            <q-btn
              color="grey-7"
              outline
              label="戻る"
              style="min-width: 120px; background: var(--q-white) !important"
              :to="{ name: 'login' }"
            />
            <q-btn
              type="submit"
              label="送信"
              icon="mdi-email-outline"
              color="primary"
              style="min-width: 120px"
            />
          </q-card-actions>
        </q-card>
      </div>
    </q-form>
    <AlertDialog
      :display="isAlertFlg"
      level="information"
      confirmation
      title="パスワード再発行完了"
      :text="[
        'パスワード再発行が完了致しました。',
        '登録されているメールアドレスに仮パスワードをご案内致しましたので、ご確認ください。',
        'ご案内メールが届かない場合は、お手数ですがお電話にてお問い合わせください。',
        '',
        'TEL：03-6262-6467',
      ]"
      @complete="router.push({ name: 'login' })"
    />
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { Loading } from 'quasar';
import axios from '../common/axios-common';
import DetailResultStatusCode from '../common/code/DetailResultStatusCode';
import AlertDialog from '../components/dialogs/AlertDialog.vue';
import PageHeaderBanner from '../components/banner/PageHeaderBanner.vue';
import { isValidateEmail, isEmpty } from '../common/utils/validateUtils';
import ResultStatusCode from '../common/code/ResultStatusCode';
import MessageChip from '../components/chip/MessageChip.vue';

const router = useRouter();
// メールアドレス
const mailAddress = ref('');
// AlertDialog表示フラグ
const isAlertFlg = ref(false);
// エラーメッセージ
const errMessage = ref('');
// MessageChip表示フラグ
const isMessageChip = ref(false);

/**
 * エラーチップを初期化
 */
const resetError = async () => {
  errMessage.value = '';
  isMessageChip.value = false;
};

/**
 * パスワード再発行
 */
const resetPassword = async () => {
  // Loading Start
  Loading.show();

  errMessage.value = '';
  isMessageChip.value = false;

  const formData = new FormData();
  formData.append('mail_address', mailAddress.value);

  await axios
    .post('/cpr001001/password-reissue', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // ダイアログ表示
          isAlertFlg.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.NOT_EMAIL_EXIST_ERROR:
            case DetailResultStatusCode.UPDATE_ERROR:
            case DetailResultStatusCode.PARAMETER_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;

            // システムエラーの場合
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch(() => {
      // エラー画面に遷移
      router.push({ name: 'error' });
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};
</script>
<style scoped>
.cpr00100-reissue-form {
  width: 65%;
  margin: 0 auto;
}
</style>

<style>
.cpr00100-reissue .message-chip .q-chip {
  margin-bottom: 10px;
}
</style>
